import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import Loading from "../molcules/Loading/Loading";
import {store} from "../store";
import {hasScope} from "../helpers/scopes";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from "@mui/material/Button";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {get} from "./api";
import {
  Link, useHistory
} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    }
}));

export default function RotaLeaveList() {
  const {state} = useContext(store);
  const canWrite = hasScope(state.user, 'rota-leave:write');
  const history = useHistory();
  const classes = useStyles();
  const [rotaLeave, setRotaLeave] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    get().then(res => {
      setIsLoading(false);
      if (res.data) {
        setRotaLeave(res.data)
      }
    }).catch(() => {
        setIsLoading(false);
    });
  }, []);

  const rowClick = (event, row) => {
      history.push( `leave/${row._id}`);
  };

  return (
    <div>
      <div className="heading"><span className="heading-text">rotaLeave</span>
        {canWrite && <Link to="leave/create" className="head-action">
          <Button variant="outlined" color="primary" startIcon={<AddCircleOutlineIcon />}>New</Button>
        </Link>}
      </div>
        {isLoading && <Loading/> }
        {!isLoading && !rotaLeave.length && <p>No rota leave found{canWrite && <React.Fragment>, <Link to="leave/create">create rota leave</Link></React.Fragment>}.</p>}
        {!isLoading && rotaLeave.length > 0 &&
        <Paper>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>

        <TableCell align="left">startTime</TableCell>

        <TableCell align="left">endTime</TableCell>

        <TableCell align="left">Site Id</TableCell>

        <TableCell align="left">User Id</TableCell>

        <TableCell align="left">Note</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {rotaLeave.map((row, index) => (
                <TableRow key={index} hover={canWrite} onClick={canWrite ? event => rowClick(event, row) : undefined}>

        <TableCell align="left">{row.startTime}</TableCell>

        <TableCell align="left">{row.endTime}</TableCell>

        <TableCell align="left">{row.siteId}</TableCell>

        <TableCell align="left">{row.userId}</TableCell>

        <TableCell align="left">{row.note}</TableCell>

                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>}
    </div>
  );
}
